<template>
  <div class="sld_member_top">
    <div class="sld_member_top_zoom clearfix">
      <div class="container">
        <dl class=" sld_left_part">
          <dt class=" sld_img_center">
            <router-link tag="a" :to="`/index`" class="flex_row_start_center">
              <img :src="configInfo.main_site_logo" :onerror="defaultImg" alt />
            </router-link>
          </dt>
        </dl>
        <div v-if="searchBox" class="sld_seach_box">
          <div class="sld_seach">
            <div class="form" @submit.prevent>
              <svg
                class="svg_search_icon"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
                data-v-029747aa=""
                @click="search"
              >
                <path
                  fill="currentColor"
                  d="m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704z"
                ></path>
              </svg>
              <input
                v-model="keyword"
                type="text"
                class="text"
                autocomplete="off"
                style="color:rgb(153,153,153);"
                :placeholder="L['请输入关键词']"
                @keyup.enter="search"
              />
              <svg
                class="svg_close_icon"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
                data-v-029747aa=""
                @click="closeSearch"
              >
                <path
                  fill="currentColor"
                  d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
                ></path>
              </svg>
            </div>
          </div>
          <!-- <div class="hot_search_wrap">
            <div>
              <template v-for="(item, index) in hotList.data" :key="index">
                <a href="javascript:void(0)" @click="quickSearch(item)">{{
                  item
                }}</a>
              </template>
            </div>
          </div> -->
        </div>
        <div class="header_right">
          <img
            class="searchIcon"
            @click="showSearchBox"
            src="@/assets/header/search.png"
            alt=""
          />
          <!-- <el-tooltip content="消息" placement="bottom" effect="light"> -->
          <router-link tag="a" :to="`/msg/list`">
            <img class="messageIcon" src="@/assets/header/message.png" alt="" />
          </router-link>
          <!-- </el-tooltip> -->
          <div class="sld_cart_wrap">
            <dl>
              <dt class="cart_icon_text_wrap">
                <!-- <span class="iconfont icon-gouwuche"></span> -->
                <router-link target="_blank" :to="`/cart/index`"
                  ><img class="shop_icon" src="@/assets/header/shop.png" alt=""
                /></router-link>
                <!-- 没有商品显示0 -->
                <div class="cart_goods_num">
                  ({{
                    cartData.data && cartData.data.availableCartNum
                      ? cartData.data.availableCartNum
                      : 0
                  }})
                </div>
              </dt>
              <!-- <dd class="cart_more_view">
                <cart-model></cart-model>
              </dd> -->
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, getCurrentInstance, watchEffect, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
// import CartModel from '@/components/CartModel'

export default {
  name: 'MemberTop',
  components: {
    // CartModel
  },
  setup () {
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const keyword = ref('')
    const curTag = ref(1) //当前选中的tag，1为首页，2为账户管理，3为消息
    const router = useRouter()
    const store = useStore()
    const cartData = reactive({ data: {} }) //获取vux的store中的购物车数据
    const memberInfo = reactive({ data: {} }) //个人信息
    const configInfo = ref(store.state.configInfo)
    const defaultImg = ref(
      'this.src="' + require('../assets/member/top_logo.png') + '"'
    )
    const searchBox = ref(false)
    onMounted(() => {
      if (store.state.loginFlag) {
        //已登录，重新获取购物车数据
        proxy.$getLoginCartListData()
        cartData.data = store.state.cartListData
      } else {
        cartData.data = store.state.cartListData
      }
      memberInfo.data = store.state.memberInfo
    })
    //搜索事件
    const search = () => {
      if (keyword.value) {
        router.push({ path: `/goods/list`, query: { keyword: keyword.value } })
      } else {
        router.push({
          path: `/goods/list`,
          query: { keyword: '' }
        })
      }
    }
    const closeSearch = () => {
      searchBox.value = false
    }
    const showSearchBox = () => {
      searchBox.value = !searchBox.value
    }
    watchEffect(() => {
      let tmpRoute = router.currentRoute.value
      if (tmpRoute.fullPath.indexOf('/msg/') > -1) {
        curTag.value = 3
      }
      cartData.data = store.state.cartListData
      memberInfo.data = store.state.memberInfo
    })
    return {
      keyword,
      search,
      L,
      cartData,
      curTag,
      memberInfo,
      configInfo,
      defaultImg,
      searchBox,
      showSearchBox,
      closeSearch
    }
  }
}
</script>

<style lang="scss" scoped>
.sld_member_top {
  .sld_member_top_zoom {
    width: 100%;
    height: 64px;
    background-color: #ffffff;
    margin-bottom: 10px;

    .container {
      display: flex;
      justify-content: space-between;
      height: 64px;
      width: 1210px;
      margin: 0 auto;
      padding-left: 0px;
      padding-right: 0px;

      // &:after,
      // &:before {
      //   display: table;
      //   content: ' ';
      // }

      .fl {
        float: left;
      }

      .fr {
        float: right;
        display: flex;
      }
    }

    .sld_left_part {
      color: #000000;

      dt {
        width: 200px;
        height: 60px;
        margin: 5px 35px 10px 0px;

        img {
          cursor: pointer;
        }

        &.sld_img_center {
          overflow: hidden;

          a {
            width: 100%;
            height: 100%;
          }

          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }
    .header_right {
      display: flex;
      align-items: center;
      img {
        margin-right: 15px;
        cursor: pointer;
      }
      .messageIcon {
        width: 22px;
        margin-top: 2px;
      }
      .sld_cart_wrap {
        // float: right;
        z-index: 99;
        height: 40px;
        // width: 165px;
        margin-right: 10px;
        margin-top: 9px;

        dl {
          margin-bottom: 0px;
          margin-right: 15px;
          position: relative;
          .shop_icon {
            width: 32px;
            height: 32px;
          }

          .cart_goods_num {
            position: absolute;
            top: 6px;
            left: 30px;
            font: 14px/18px Verdana;
            color: #ced7df;
            // background: $colorMain;
            text-align: center;
            display: inline-block;
            height: 16px;
            min-width: 16px;
            border: none 0;
            border-radius: 8px;
          }
        }

        dd {
          position: absolute;
          top: 38px;
          right: 0;
          width: 355px;
          border: 1px solid #e3e3e3;
          background: #fff;
          z-index: 1;
        }
        .cart_more_view {
          display: none;

          .empty_cart {
            width: 100%;
            position: relative;

            .empty_cart_line {
              position: absolute;
              width: 163px;
              right: 0;
              height: 2px;
              // top: -2px;
              z-index: 999;
              background: #fff;
            }

            .empty_cart_txt {
              padding: 10px;
              color: #999;
            }
          }
        }

        &:hover .cart_more_view {
          display: inline-block;
        }
      }
    }
    .sld_seach_box {
      width: 680px;
      height: 99px;
      margin: 18px auto 0;
      margin-bottom: 3px;

      .sld_seach {
        display: flex;
      }

      .form {
        // border: 2px solid $colorMain;
        border: 2px solid #00a2e8;
        // background-color: $colorMain;
        height: 38px;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;

        .svg_search_icon {
          color: #c0c0c0;
          width: 18px;
          height: 18px;
          margin-left: 5px;
          margin-top: 9px;
          cursor: pointer;
          position: absolute;
        }

        .text {
          width: 591px;
          height: 38px;
          -webkit-appearance: none;
          -webkit-border-radius: 0;
          padding: 5px 5px 5px 30px;
          background-position: 0 -360px;
          background-color: #fff;
          background-repeat: repeat-x;
          font-family: arial, '\5b8b\4f53';
          font-size: 14px;
          outline: none;
          border: none;
        }
        .svg_close_icon {
          color: #c0c0c0;
          width: 18px;
          height: 22px;
          margin-top: 5px;
          position: absolute;
          right: 10px;
          cursor: pointer;
        }

        // input {
        //   margin: 0;
        //   padding: 0;
        //   height: 34px;
        //   border: 0;
        // }

        // .button {
        //   width: 103px;
        //   background: $colorMain;
        //   font-size: 16px;
        //   font-weight: 600;
        //   color: #fff;
        //   float: right;
        //   cursor: pointer;
        // }
      }
      .release {
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        color: #ffffff;
        line-height: 38px;
        background-color: #00a2e8;
        margin-left: 2px;
        cursor: pointer;
      }

      .hot_search_wrap {
        height: 30px;
        line-height: 30px;
        color: #999;
        overflow: hidden;

        strong {
          float: left;
          font-weight: 400;
        }

        a {
          color: #666;

          &:link,
          &:visited {
            float: left;
            margin-right: 10px;
          }

          &:hover {
            color: $colorMain;
          }
        }
      }
    }
  }
}
</style>
